/**
 * @name                                    main.ts
 * @description                             the main file (entry point)
 * @author                                  Maysara Elshewehy
 * @repo                                    https://github.com/je-es/style
 *
 * @note                                    This script follows the `MECS` code style
*/


/* ---------------------------------------- PACK ----------------------------------------  */

    export *                                from './modules/design';
    export *                                from './modules/style';

/* ---------------------------------------- ---- ----------------------------------------  */